import React from 'react';
import './style.scss';

import { ReactComponent as CheckMark } from '@assets/images/check-mark.svg';

import { cn } from '@global/utils/styling';
import {
  COMMON_CHECKBOX_TEST_ID,
  COMMON_CHECKBOX_INPUT_TEST_ID,
} from './consts';

export interface CommonCheckboxProps {
  children?: React.ReactNode;
  checked?: boolean;
  toggle?: () => void;
  disabled?: boolean;
  isValid?: boolean;
  error?: boolean;
  errorMessage?: string;
}

export const CommonCheckbox = ({
  children,
  checked,
  toggle,
  disabled,
  isValid,
  error,
  errorMessage,
}: CommonCheckboxProps) => {
  return (
    <label className="common-checkbo" data-testid={COMMON_CHECKBOX_TEST_ID}>
      <input
        data-testid={COMMON_CHECKBOX_INPUT_TEST_ID}
        type="checkbox"
        hidden
        disabled={disabled}
        onChange={toggle}
      />
      <div
        className={cn('common-checkbox__input', {
          'common-checkbox__input--disabled': disabled,
        })}
      >
        <div
          tabIndex={0}
          className={cn('common-checkbox__input-icon', {
            'common-checkbox__input-icon--checked': checked,
            'common-checkbox__input-icon--disabled': disabled,
            'common-checkbox__input-icon--valid': isValid,
            'common-checkbox__input-icon--error': error,
          })}
        >
          {checked ? (
            <CheckMark className="common-checkbox__check-mark" />
          ) : null}
        </div>
        <div>{children}</div>
      </div>
      {error && errorMessage && (
        <p className="common-checkbox__error-message">{errorMessage}</p>
      )}
    </label>
  );
};
